// extracted by mini-css-extract-plugin
module.exports = {"bordaEstiloC":"Registro_bordaEstiloC__2QBh7","bordaEstiloB":"Registro_bordaEstiloB__34Vb5"};